<template>
  <div class="animated fadeIn">
    <CRow>
      <CCol lg="12">
        <CCard>
          <CCardBody>
            <CRow>
              <CCol lg="3">
                <div class="Agent">
                  <label for="filterAgent">Seller</label>
                  <model-select
                    class="form-control"
                    id="filterAgent"
                    :options="agentList"
                    v-model="agent"
                    placeholder="-- Harap pilih salah satu --"
                  ></model-select>
                </div>
              </CCol>
              <CCol lg="3">
                <div class="Agent">
                  <label for="fitlterStatusProduct">Status</label>
                  <model-select
                    class="form-control"
                    id="fitlterStatusProduct"
                    :options="statusProductList"
                    v-model="product_status"
                    placeholder="-- Harap pilih salah satu --"
                  ></model-select>
                </div>
              </CCol>
            </CRow>
          </CCardBody>
        </CCard>
      </CCol>
    </CRow>

    <CRow>
      <CCol lg="12">
        <div class="card">
          <div class="card-header">Export data Product</div>
          <div v-if="loading == true">
            <loading></loading>
          </div>
          <div class="card-body" v-if="loading == false">
            <br />
            <div class="col-lg-3">
              <CButton type="button" size="sm" @click="downloadfile" color="info">
                <i class="fa fa-save"></i> Download
              </CButton>
            </div>
          </div>
        </div>
      </CCol>
    </CRow>

    <!-- <div class="card">
      <div class="card-header">Export data Product</div>
      <div v-if="loading == true">
        <loading></loading>
      </div>
      <div class="card-body" v-if="loading == false">
              <br>
        <div class="col-lg-3">
          <CButton type="button" size="sm" @click="downloadfile" color="info">
            <i class="fa fa-save"></i> Download
          </CButton>
        </div>
      </div>
    </div> -->
  </div>
</template>

<script>
import axios from "axios";
import loading from "@/templates/Loading.vue";
import { ModelSelect } from "vue-search-select";
import * as moment from "moment";

export default {
  name: "order_history",
  components: {
    loading,
    ModelSelect,
  },
  data() {
    return {
      loading: false,
      agentList: [],
      statusProductList: [],
      agent: null,
      product_status: null,
    };
  },
  notifications: {
    showErrorNotification: {
      title: "Error Title",
      message: "Messages",
      type: "error",
    },
    showInfoNotification: {
      title: "Info Title",
      message: "Messages",
      type: "info",
    },
  },
  methods: {
    init: function () {
      this.loading = false;
      this.getDropdown();
    },
    getDropdown: function () {
      this.axios.get("/console/dropdown/export-product").then((response) => {
        this.agentList = response.data.agent;
        this.statusProductList = response.data.product_status;
      });
    },
    downloadfile: function () {
      if (confirm("Are You Sure?")) {
        //this.loading = true;
        this.loading = true;
        var param = {};
        param.agent_code = this.agent === null ? "all" : this.agent;
        param.product_status = this.product_status === null ? "all" : this.product_status;

        this.axios({
          url: "console/export/product/all",
          method: "POST",
          data: param,
          responseType: "blob",
        })
          .then((response) => {
            const url = window.URL.createObjectURL(new Blob([response.data]));
            const link = document.createElement("a");
            link.href = url;
            link.setAttribute("download", "product_isikulkas.xlsx");
            document.body.appendChild(link);
            link.click();
          })
          .catch((error) => {
            if (error.response.status === 401) {
              this.expired(error, "");
            }
          })
          .finally(() => {
            this.loading = false;
          });
        //window.location.href = axios.defaults.baseURL+'web/export/data-employee/';
      }
    },
    expired: function (error, title) {
      if (error.response.status === 401) {
        localStorage.clear();
        this.$router.push({ path: "/login" });
        this.showErrorNotification({
          title: "Token Expired",
          message: "Your session has been expired",
        });
      } else {
        this.showErrorNotification({
          title: title,
          message: error.response.data.message,
        });
      }
    },
  },
  mounted() {
    this.init();
  },
};
</script>

<style></style>
